module.exports = __webpack_public_path__ + "static/media/apartment.7cb6edf5.jpg";